import { useMutation } from "react-query";

import { NetworkResponse } from "~/app/type/common";
import {
  IRegMenReportFilters,
  IReportFileHash,
} from "~/entity/RegMenReports/model/schema";
import { useNotify } from "~/shared/hooks/useNotify";

type RegMenReportRequest<T> = (
  filters: IRegMenReportFilters,
) => NetworkResponse<T>;

export const useRegMenReportMutation = <T>(request: RegMenReportRequest<T>) => {
  const { data, isLoading, isError, mutate, reset } = useMutation({
    mutationFn: (filters: IRegMenReportFilters) => request(filters),
  });

  return { data: data?.data, isLoading, isError, mutate, reset };
};

export const useRegMenReportFileMutation = (
  request: RegMenReportRequest<IReportFileHash>,
  onSuccess?: () => void,
) => {
  const { notifyReport } = useNotify();

  const { isLoading, isError, mutate } = useMutation({
    mutationFn: (filters: IRegMenReportFilters) => request(filters),
    onSuccess: (response) => {
      const hash = response?.data?.fileHash;
      if (hash) {
        notifyReport(hash);
        onSuccess && onSuccess();
      }
    },
  });

  return { isLoading, isError, mutate };
};
